import React, { useEffect, useState, useContext } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import styles from './style.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getEnvInfo } from 'api/resources';
import Hamburger from './Hamburger';
import style from '../../pages/Account/style.module.scss';
import { pathDisplayPageAfterLogin } from '../../utils/utils';
import RenderSvgIcon from '../RenderSvgIcon';
import { AuthContext } from '../../context/AuthContext';
import { AppContext } from '../../context/AppContext';

const wrapStyleArrow = {
  paddingRight: 3,
  width: 24,
  height: 24,
  color: 'var(--text-secondary)',
  fill: 'currentColor',
  cursor: 'pointer',
};

function TopNav(props) {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();

  const listEnvInfo = appContext.listEnvInfo;
  const envUi = authContext.envUi;

  const backToSetting = () => {
    if (props.dataLocation && props?.dir) {
      history.push({ pathname: props?.dir, state: { data: props.dataLocation } });
      return;
    }
    if (props?.dir) {
      if (props?.dir === '/') window.location.href = '/';
      history.push(props.dir);
      return;
    }

    history.goBack();
  };

  const [mainColor, setMainColor] = useState('#8f8f8f');

  useEffect(() => {
    if (listEnvInfo) {
      const color = listEnvInfo.find((data) => data.code === '--text1');
      if (color?.content) {
        setMainColor(color.content);
      }
    }
  }, [listEnvInfo]);

  const clickLogo = () => {
    if (props?.preventLogoClick) {
      return;
    }
    history.push({ pathname: pathDisplayPageAfterLogin(envUi?.displayPageAfterLogin) });
  };

  const topNavibarLogo = (listEnvInfo || []).find((item) => item.code === 'top_navibar_logo');

  return (
    <div className={`${styles.top__nav} height-top-navi`}>
      <div style={{ position: 'relative' }}>
        {props?.hasLogo && topNavibarLogo && (
          <div className={`${styles.web__logo} d-box-logo`} onClick={clickLogo}>
            <img src={topNavibarLogo?.content} className={style.icon} alt="Contact" />
          </div>
        )}
        <h6 variant="h6" className="font-1" style={{ lineHeight: 2.4, textAlign: 'center' }}>
          {props?.name}
        </h6>
        {props.hasBackIcon && (
          <span className={`${styles.backIcon} iframe-pre-hidden-btn`} onClick={backToSetting}>
            <RenderSvgIcon name="SVG_forward_left_icon" style={wrapStyleArrow} className={'d-svg'} />
          </span>
        )}
        {props?.hasHamburger && envUi && +envUi?.displayTopNaviMenu === 0 && <Hamburger envUi={envUi} />}
      </div>
    </div>
  );
}

export default TopNav;
